import { useEffect } from "react";

import { Box, Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@app/store";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { setMessages, useDeleteMessageMutation, useLazyGetMessagesQuery } from "@modules/messages";

import { StyledTableBody } from "@pages/Products/styled";

const Messages = () => {
  const dispatch = useAppDispatch();
  const messagesList = useAppSelector((state) => state.message.messages)

  const [getMessages] = useLazyGetMessagesQuery()
  const [deleteMessage] = useDeleteMessageMutation()

  const handleGetRequest = async () => {
    try {
      const messages = await getMessages().unwrap();

      dispatch(setMessages(messages));
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteMessage = async (id: string) => {
    if (!id) {
      return null
    }

    try {
      await deleteMessage({ id })
      handleGetRequest()
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    handleGetRequest()
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}
    >
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">NAME</TableCell>
              <TableCell align="center">MESSAGE</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <StyledTableBody>

            {messagesList.map((message) => {
              return (
                <TableRow key={message.id}>
                  <TableCell align="center">{message.name}</TableCell>
                  <TableCell align="center">{message.message}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      onClick={() => handleDeleteMessage(message.id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              )
            })}
          </StyledTableBody>
        </Table>
      </TableContainer>
    </Box>
  )
};

export default Messages;
